import { useContext } from "react";
import { AbTest } from "src/api/types";
import { AbTestContext } from "./AbTestsProvider";

export function useAbTests<T>(selector: (tests: AbTest) => T): T | undefined {
  const abTests = useContext(AbTestContext);
  return selector(abTests);
}
